import React, { Component } from 'react'
import { Field } from 'formik'
import { Input, Select } from '../../../ui/forms/formik'
import { Row, Col } from 'react-bootstrap'
import SelectNormal from '../../../ui/select/SelectNormal'
import Alert from '../../../ui/feedback/Alert'

let currentYear = new Date().getFullYear();
currentYear = parseInt(currentYear);
const YearsSelectOptions = [...Array(30)].map((i, idx) => ({ label: currentYear + idx, value: currentYear + idx }))
const MonthSelectOptions = [...Array(12)].map((i, idx) => ({ label: idx + 1, value: idx + 1 }))

class PaymentDetailsForm extends Component {
    render() {
        return (
            <div className="company-details-form">
                <Row className="gutters-12">
                    <Col md={12}>
                        <Field
                            name="cardName"
                            placeholder="Name on Card"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                    <Col md={8}>
                        <Field
                            name="cardNumber"
                            placeholder="Your Credit Card Number"
                            mask="9999 9999 9999 9999"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                    <Col md={4}>
                        <Field
                            name="cvv"
                            type="password"
                            placeholder="CVV"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                    </Col>
                    <Col md={6}>
                        <Field
                            name="expiryMonth"
                            placeholder="Expiry Month"
                            component={Select}
                            wrappedComponent={SelectNormal}
                            className="select select-flat select-xl grid-select-menu"
                            options={MonthSelectOptions}
                        />
                    </Col>
                    <Col md={6}>
                        <Field
                            name="expiryYear"
                            placeholder="Expiry Year"
                            component={Select}
                            wrappedComponent={SelectNormal}
                            className="select select-flat select-xl grid-select-menu"
                            options={YearsSelectOptions}
                        />
                    </Col>
                    <Col md={12}>
                        <Alert>
                            Your card details are secured with us, We don’t share any of your credit card details with anyone
                        </Alert>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default PaymentDetailsForm